import { faArrowsRotate, faCopy } from '@fortawesome/pro-light-svg-icons'
import PermissionChecker from '../../../../../../../../../baseComponents/PermissionChecker'
import { TwinIconToolTip } from '../../../../../../../../../baseComponents/TwinIcon'
import { OrderData } from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/types'
import useEditDeleteModal from '../../../../../../../../../utils/hooks/useEditDeleteModal'
import { getUserPermissions } from '../../../../../../../../../utils/reducers/getters'
import ModalSellOrderDuplicate from './ModalSellOrderDuplicate'
import ModalRecalculateSellOrder from './ModalRecalculateSellOrder'

interface SellOrderDuplicateButtonProps {
    allRowData: OrderData
    title: string
    children?: React.ReactNode
    id: string
}

export const SellOrderDuplicateButton: React.FC<SellOrderDuplicateButtonProps> = ({ allRowData, id, title, children }) => {
    const { openModal, setOpenModal } = useSellOrderDuplicateButtonLogic()
    return (
        <PermissionChecker permission='create' userPermissions={getUserPermissions('sell.order')}>
            <div onClick={() => setOpenModal({ type: 'create', allRowData })}>
                { children ?? <TwinIconToolTip classNameIcon='hover:text-green-43 regular22' message={title} icon={faCopy} id={id} />}
            </div>
            {openModal?.type === 'create' ? <ModalSellOrderDuplicate setOpened={() => setOpenModal({ type: 'delete', allRowData })} allRowData={allRowData} onSubmit={() => { }} /> : null}
        </PermissionChecker>
    )
}

const useSellOrderDuplicateButtonLogic = () => {
    const { openModal, setOpenModal } = useEditDeleteModal()

    return { openModal, setOpenModal }
}

interface SellOrderRecalculateButtonProps {
    allRowData: OrderData
    onSubmit?: () => void
    title: string
    children?: React.ReactNode
    id: string
}

export const SellOrderRecalculateButton: React.FC<SellOrderRecalculateButtonProps> = ({ allRowData, onSubmit, id, title, children }) => {
    const { openModal, setOpenModal } = useSellOrderRecalculateButtonLogic()
    return (
        <PermissionChecker permission='update' userPermissions={getUserPermissions('sell.order')}>
            <div onClick={() => setOpenModal({ type: 'create', allRowData })}>
                {children ?? <TwinIconToolTip classNameIcon='hover:text-green-43 regular22' message={title} icon={faArrowsRotate} id={id} />}
            </div>
            {openModal?.type === 'create' ? <ModalRecalculateSellOrder setOpened={() => setOpenModal({ type: 'delete', allRowData })} allRowData={allRowData} onSubmit={() => onSubmit?.()} /> : null}
        </PermissionChecker>
    )
}

const useSellOrderRecalculateButtonLogic = () => {
    const { openModal, setOpenModal } = useEditDeleteModal()

    return { openModal, setOpenModal }
}